import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useState } from "react";
import {
  createGrowthGoalsByStudentAndDR as createGrowthGoalsByStudentAndDRService,
  deleteGrowthGoals as deleteGrowthGoalsService,
} from "../../services/growth-goals/growth-goals.service.js";
import { handlerErrorV2 } from "../../utils/errors.jsx";
import { toggleAlertModule } from "../../store/actions/alert.actions";

const useGrowthGoals = () => {
  const { curriculumId, ulId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const createGrowthGoalsByStudentAndDR = async (studentId, questionId, data) => {
    try {
      const response = await createGrowthGoalsByStudentAndDRService(
        curriculumId,
        ulId,
        studentId,
        questionId,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        enqueueSnackbar("Growth goals saved successfully", {
          variant: "success",
        });
        dispatch(toggleAlertModule());
        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const deleteGrowthGoals = async (ggId) => {
    setIsLoading(true);
    try {
      const response = await deleteGrowthGoalsService(
        curriculumId,
        id,
        ggId
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        enqueueSnackbar("Growth goals deleted successfully", {
          variant: "success",
        });

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    createGrowthGoalsByStudentAndDR,
    deleteGrowthGoals,
  };
};

export default useGrowthGoals;
